export default {
    trial: {
        go_billing: 'GO TO BILLING',
        upgrade: 'UPGRADE',
        expired: 'Your PREMIUM trial period has expired!',
        cotninue_recieving: 'to continue recieving referrals',
        ending: 'Your PREMIUM trial period is ending in less than <<24>> hours! | Your PREMIUM trial period is ending in <<1>> day! | Your PREMIUM trial period is ending in <<{numberOfDays}>> days!',
        demo_account: 'This is a demo account. Complete registration for full features.',
        finish_registration: 'START TODAY',
    },
    billing_address_modal: {
        edit: 'Edit billing address',
        address_label: 'Address',
        address_placeholder: 'address',
        city_label: 'City',
        city_placeholder: 'city',
        state_label: 'State',
        state_placeholder: 'state',
        zip_label: 'Zip',
        zip_placeholder: 'zip',
    },
    billing_list_modal: {
        heading: 'Saved Credit Cards',
        content: 'Manage your saved cards securely',
        credit_card: 'Credit Card:',
        active: 'Active',
        delete: 'Delete',
        delete_card: 'Are you sure you want to delete card',
        secure: 'Your payment information is secure and encrypted.',
    },
    premium: 'PREMIUM',
    enterprise: 'ENTERPRISE',
    network: 'NETWORK',
    features: 'Features',
    billing_details: 'Billing details',
    payment_method: 'Payment method',
    on_annual: 'on annual billing',
    primary: 'Primary',
    billing_form: {
        monthly: 'Monthly billing',
        annual: 'Annual billing',
        year: '/year',
        month: '/month',
        billing_address: 'Billing address',
        street: 'Enter your street address',
        city: 'Enter your city',
        state: 'Enter your state',
        postcode: 'Enter your postcode',
    },
    table: {
        payment_history: 'Payment history',
        period: 'Period',
        fee: 'Fee',
        concierge: 'Concierge fees',
        total: 'Total',
        paid: 'Paid on',
        Invoice: 'Invoice',
        appointments: 'appointments',
        invoice: 'INVOICE',
        no_history: 'No payment history',
    },
    invoice_modal: {
        download: 'DOWNLOAD INVOICE',
        subscription: 'Subscription',
        period: 'Period',
        transcations: 'Transactions',
        amount: 'Amount',
        premium: 'Premium',
    },
}
